"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TYPE_TOOL_SERVICE = 'TYPE_TOOL_SERVICE';
exports.TYPE_CONFIG_TOOL_PREFIX = 'TYPE_CONFIG_TOOL_PREFIX';
exports.TYPE_DRIVER_REQUIRE = 'TYPE_DRIVER_REQUIRE';
exports.TYPE_FACTORY_TOOL_CONTAINER = 'TYPE_FACTORY_TOOL_CONTAINER';
exports.TYPE_API = 'TYPE_API';
